import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_USERS,
    FETCH_USERS_FAILURE,
    FETCH_USERS_SUCCESS,
    FETCH_PHONE_CODES,
    FETCH_PHONE_CODES_FAILURE,
    FETCH_PHONE_CODES_SUCCESS,
    INITIALIZE_FORM,
    RESET,
    RESET_FORM,
    SAVE_CONTACT,
    SAVE_CONTACT_FAILURE,
    SAVE_CONTACT_SUCCESS,
    SET_IS_NEW_RECORD,
    SHOW_MODAL,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    users: {
        data: [],
        error: null,
        isLoading: false,
    },
    contact: {
        isLoading: false,
        errors: [],
    },
    initialValues: {
        company_name: '',
        company_position: '',
        emails: [],
        id: null,
        name: '',
        rfc: '',
        status_flag: 'active',
        telephones: [],
    },
    isNewRecord: false,
    isOpenModal: false,
    phoneCodes: {
        data: {},
        error: null,
        isFetching: false,
    },
};

const createContactModalSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH_USERS]: (state) => {
            state.users.isLoading = true;
        },
        [FETCH_USERS_FAILURE]: (state, action) => {
            state.users = {
                ...state.users,
                error: action.payload,
                isLoading: false,
            };
        },
        [FETCH_USERS_SUCCESS]: (state, action) => {
            state.users = {
                ...state.users,
                data: action.payload,
                isLoading: false,
            };
        },
        [FETCH_PHONE_CODES]: (state) => {
            state.phoneCodes = {
                ...state.phoneCodes,
                isLoading: true,
            };
        },
        [FETCH_PHONE_CODES_FAILURE]: (state, action) => {
            state.phoneCodes = {
                ...state.phoneCodes,
                error: action.payload,
                isLoading: false,
            };
        },
        [FETCH_PHONE_CODES_SUCCESS]: (state, action) => {
            state.phoneCodes = {
                ...state.phoneCodes,
                data: action.payload,
                isLoading: false,
            };
        },
        [INITIALIZE_FORM]: (state, action) => {
            state.contact.errors = null;
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [RESET]: () => INITIAL_STATE,
        [RESET_FORM]: (state) => {
            state.contact = {
                ...state.contact,
                errors: [],
                isLoading: false,
            };
            state.initialValues = INITIAL_STATE.initialValues;
        },
        [SAVE_CONTACT]: (state) => {
            state.contact.errors = null;
            state.contact.isLoading = true;
        },
        [SAVE_CONTACT_FAILURE]: (state, action) => {
            state.contact = {
                ...state.contact,
                errors: action.payload,
                isLoading: false,
            };
        },
        [SAVE_CONTACT_SUCCESS]: (state) => {
            state.contact.isLoading = false;
        },
        [SET_IS_NEW_RECORD]: (state, action) => {
            state.isNewRecord = action.payload;
        },
        [SHOW_MODAL]: (state, action) => {
            state.isOpenModal = action.payload;
        },
    },
});

export const createContactModalActions = createContactModalSlice.actions;

export default createContactModalSlice.reducer;
